import styled from 'styled-components';
import { Black1 } from '../../styles/colours';
import { DemiBold } from '../../styles/fonts';

export const PageHeading = styled.h1`
  display: flex;
  flex-direction: row;

  font-family: ${DemiBold};

  margin: 2rem 0;
  padding: 0;

  font-size: 1.5rem;
  color: ${Black1};
`;
